<template>
    <form :id="controlId">
        <slot></slot>
    </form>
</template>

<script>
import framework from '../../framework';
/**
 *  The x-form component.
 *  @module components/x-form
 */


/**
 * Form Component
 */
export default {
    name: 'x-form',
    mixins: [
        framework.mixins.abstractElement,
    ],
};
</script>


// WEBPACK FOOTER //
// source/components/x-form/x-form.vue